/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataPageOfPatientPurge } from '../../models/data-page-of-patient-purge';

export interface PatientArchivePatientPurgeSearch$Params {
  searchText?: string | null;
  dob?: string | null;
  mrn?: string | null;
  pageNumber?: number;
  SortByColumn?: string | null;
  SortByDirection?: string | null;
}

export function patientArchivePatientPurgeSearch(http: HttpClient, rootUrl: string, params?: PatientArchivePatientPurgeSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfPatientPurge>> {
  const rb = new RequestBuilder(rootUrl, patientArchivePatientPurgeSearch.PATH, 'get');
  if (params) {
    rb.query('searchText', params.searchText, {});
    rb.query('dob', params.dob, {});
    rb.query('mrn', params.mrn, {});
    rb.query('pageNumber', params.pageNumber, {});
    rb.query('SortByColumn', params.SortByColumn, {});
    rb.query('SortByDirection', params.SortByDirection, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataPageOfPatientPurge>;
    })
  );
}

patientArchivePatientPurgeSearch.PATH = '/api/PatientArchive/patientarchive/patientPurgeSearch';
